import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import { getAllPayments } from '../../store/apiSlice/PaymentSlice';
import { format, parse } from 'date-fns';
import {
  Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, Paper, Typography
} from '@mui/material';
import { Link } from 'react-router-dom';


const Paymentsuser = () => {
  const dispatch = useDispatch();
  const paymentData = useSelector((state) => state.rootReducer.paymentsReducer.data);
  const [payments, setPayments] = useState(null)

  useEffect(() => {
    dispatch(getAllPayments())
  }, [])

  useEffect(() => {
    if (paymentData && paymentData.status === 1) {
      setPayments(paymentData.data)
    }
  }, [paymentData])


  return (
    <div className="row" >
      <div style={{ padding: '2rem', paddingTop: '0.5rem' }}>
        <Typography variant="h5" gutterBottom style={{ paddingBottom: '1rem' }}>
          Payment History
        </Typography>

        {payments && <TableContainer component={Paper}>
          <Table aria-label="payment table">
            <TableHead>
              <TableRow >
                <TableCell style={{ fontSize: '15px', fontWeight: 600 }} >Order ID</TableCell>
                <TableCell style={{ fontSize: '15px', fontWeight: 600 }} >Amount</TableCell>
                <TableCell style={{ fontSize: '15px', fontWeight: 600 }} >Currancy</TableCell>
                <TableCell style={{ fontSize: '15px', fontWeight: 600 }} >Gateway</TableCell>
                <TableCell style={{ fontSize: '15px', fontWeight: 600 }} >Date</TableCell>
                <TableCell style={{ fontSize: '15px', fontWeight: 600 }} >Invoice</TableCell>
                <TableCell style={{ fontSize: '15px', fontWeight: 600 }} >Status</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {payments?.length > 0 ? (
                payments.map((payment, index) => (
                  <TableRow key={payment._id}>
                    <TableCell>{payment.orderId}</TableCell>
                    <TableCell>€{(payment.amount).toFixed(2)}</TableCell>
                    <TableCell>{payment.currency}</TableCell>
                    <TableCell>{payment.paymentGateway}</TableCell>
                    <TableCell>{format(new Date(payment.updatedAt), 'MMMM d, yyyy') || 'NA'}</TableCell>
                    <TableCell>
                      <Link to={payment.receiptUrl} target="_blank" rel="noopener noreferrer">
                        View
                      </Link>
                    </TableCell>
                    <TableCell>{payment?.stripePaymentStatus ? payment?.stripePaymentStatus : payment.paymentStatus}</TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={5} align="center">
                    No payments found
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>}
      </div>
    </div>
  )
}

export default Paymentsuser
